import Layout from '@/components/Layout';

export default [
  {
    path: '/monitor',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'index',
      },
      {
        path: 'index',
        component: () => import('@/views/monitor'),
        name: 'dataView',
        meta: {
          title: '监测数据',
          attachProject: true,
        },
      },
      {
        path: 'group',
        component: () => import('@/views/monitor/group'),
        name: 'groupDataView',
        meta: {
          title: '组合监测',
          attachProject: true,
        },
      },
    ],
  },

];
